var _defs, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    width: 30.161,
    height: 31.636,
    viewBox: "0 0 30.161 31.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#414141}.cls-2{fill:none;stroke:#b8b8b8;stroke-miterlimit:10}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    d: "M30.961 25.772H.8v-5.737a9.864 9.864 0 0 1 9.835-9.835h1.8v.82a1.12 1.12 0 0 0 1.147 1.147h4.1a1.12 1.12 0 0 0 1.147-1.147v-.82h2.295a9.864 9.864 0 0 1 9.835 9.835zM2.439 24.133h26.882v-4.1a8.116 8.116 0 0 0-8.2-8.2h-.82a2.806 2.806 0 0 1-2.623 1.967h-4.1a2.657 2.657 0 0 1-2.623-1.967h-.328a8.116 8.116 0 0 0-8.2 8.2v4.1z",
    className: "cls-1",
    "data-name": "Path 83",
    transform: "translate(-.8 5.864)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    d: "M6.595 17.775c-2.131-2.623-2.295-7.54-2.295-7.7C4.3 4.17 7.906.4 13.315.4s9.015 3.77 9.015 9.671c0 .164 0 4.754-2.131 7.7l-1.311-.983c1.8-2.459 1.967-6.721 1.967-6.721 0-4.917-2.787-8.032-7.376-8.032C9.873 2.039 6.1 4.17 6.1 10.071c0 0 .164 4.59 1.967 6.721z",
    className: "cls-1",
    "data-name": "Path 86",
    transform: "translate(1.437 -.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    d: "M12.047 16.477a5.44 5.44 0 0 1-4.1-1.967A6.661 6.661 0 0 1 6.31 9.593a11.135 11.135 0 0 1 2.95-5.9l.492-.493.492.492a9.076 9.076 0 0 0 4.262 1.639c2.623.492 3.114 3.114 3.114 4.262.164 3.77-2.459 6.884-5.573 6.884zm-4.1-6.721a4.93 4.93 0 0 0 1.313 3.607 4.04 4.04 0 0 0 2.787 1.311c2.295 0 4.1-2.295 4.1-5.245 0-.164 0-2.459-1.8-2.623a11.243 11.243 0 0 1-4.431-1.475 10.157 10.157 0 0 0-1.967 4.426z",
    className: "cls-1",
    "data-name": "Path 87",
    transform: "translate(2.706 1.39)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(16.228 23.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M10.7 14.8v3.606h6.229V14.8zm5.081 2.295c-.164 0-.164 0-.328-.164 0-.164-.164-.164-.492-.164-.492 0-.492.328-.492.328a.328.328 0 1 1-.656 0c0-.164 0-.328-.328-.328h-.164a.508.508 0 0 0-.164.328.353.353 0 0 1-.328.328.353.353 0 0 1-.328-.328c0-.164 0-.328-.492-.328a.572.572 0 0 0-.328.164c0 .164-.164.164-.328.164s-.328-.164-.164-.328a.991.991 0 0 1 .983-.492.852.852 0 0 1 .656.328c.164-.164.328-.164.656-.164a.852.852 0 0 1 .656.328 1.252 1.252 0 0 1 .82-.328 1.4 1.4 0 0 1 .983.492c.164-.164 0 .164-.164.164z",
    className: "cls-1",
    "data-name": "Path 88",
    transform: "translate(-10.7 -14.8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.c5cf47f96dd9618ba62c1e402e7cb672.svg";
export { ForwardRef as ReactComponent };